// import React, { useState } from "react";
// import "./header.css";
// import { NavLink } from "react-router-dom";
// import { Button } from "@mui/material";
// import { AiFillContacts, AiFillMail, AiOutlineUser } from "react-icons/ai";
// import { logoutAccess, useSelectAccess } from "../../store/stateFunctions";
// import Menu from "@mui/joy/Menu";
// import MenuButton from "@mui/joy/MenuButton";
// import MenuItem from "@mui/joy/MenuItem";
// import Dropdown from "@mui/joy/Dropdown";

// const Header = () => {
//   const student = useSelectAccess("Student");
//   const industry = useSelectAccess("Industry User");
//   const merchant = useSelectAccess("Merchant");

//   const userNotPresent = !student && !industry && !merchant;
//   console.log("User not present:", userNotPresent);

//   // const [color, setColor] = useState(false);
//   // const changeColor = () => {
//   //   if (window.scrollY >= 90) {
//   //     setColor(true);
//   //   } else {
//   //     setColor(false);
//   //   }
//   // };

//   // window.addEventListener("scroll", changeColor);
//   return (
//     <>
//       {/* <div className="container-fluid bg-white">
//         <div className="row gx-0">
//           <div className="col-md-2  text-center text-lg-start  ">
//             <div className="d-inline-flex align-items-center">
//               <a
//                 className="text-dark px-3"
//                 href="https://twitter.com/my_nmc"
//                 target="_blank"
//               ></a>
//               <a
//                 className="text-dark px-3"
//                 href="https://www.facebook.com/mynashikmc/"
//                 target="_blank"
//               >
//                 <i className="fab fa-facebook"></i>
//               </a>
//               <a
//                 className="text-dark px-3"
//                 href="https://www.instagram.com/my_nmc/"
//                 target="_blank"
//               >
//                 <i className="fab fa-instagram"></i>
//               </a>
//               <a
//                 className="text-dark px-3"
//                 href="https://www.youtube.com/c/mynmc"
//                 target="_blank"
//               >
//                 <i className="fab fa-youtube"></i>
//               </a>
//               <a
//                 className="text-dark px-3"
//                 href="https://www.youtube.com/c/mynmc"
//                 target="_blank"
//               >
//                 <i className="fab fa-twitter"></i>
//               </a>
//             </div>
//           </div>
//           <div className="col-md-6 text-center"></div>
//           <div className="col-md-4 text-white pt-1  text-lg-start ">
//             <p>
//               <AiFillMail /> enquiry@theinnovativesolutions.in /
//               <span>
//                 <AiFillContacts /> 9371001138
//               </span>
//             </p>
//           </div>
//         </div>
//       </div> */}
//       {/* <div className="social">
//         <a href="https://www.facebook.com/profile.php?id=100094476235504">
//           Facebook<i className="fab fa-facebook"></i>
//         </a>
//         <a href=" https://www.instagram.com/the.innovative.solutions">
//           Instagram<i className="fab fa-instagram"></i>
//         </a>
//         <a href="https://www.linkedin.com/in/the-innovative-solutions-18255222a/">
//           Linkedin<i className="fab fa-linkedin"></i>
//         </a>
//         <a href="https://twitter.com/theinnovatives3?t=ZQHRr29rvQHbPC8qRTnpJg&s=09">
//           Twitter<i className="fab fa-twitter"></i>
//         </a>
//       </div> */}
//       <div>
//         <div className="row align-self-center justify-content-center">
//           <div className="col-md-2 text-center align-self-center">
//             {" "}
//             <NavLink to="/" className="navbar-brand mt-1" rel="noreferrer">
//               <img src="/images/Untitled design.png" width={100} alt="" />
//             </NavLink>
//           </div>
//           <div className="col-md-8  align-self-center">
//             <h1 className="fw-bold"> मराठवाडा सामाजिक फाऊंडेशन, महाराष्ट्र</h1>
//           </div>
//         </div>
//       </div>

//       <nav
//         // className={
//         //   color
//         //     ? "navbar nav2  text-uppercase fw-bold navbar-expand-lg shadow-sm sticky-top"
//         //     : "navbar text-uppercase fw-bold navbar-expand-lg shadow-sm sticky-top"
//         // }
//         className="navbar text-uppercase fw-bold navbar-expand-lg shadow-sm sticky-top"
//       >
//         <div className="container-fluid">
//           <button
//             className="navbar-toggler"
//             type="button"
//             data-bs-toggle="collapse"
//             data-bs-target="#navbarSupportedContent"
//             aria-controls="navbarSupportedContent"
//             aria-expanded="false"
//             aria-label="Toggle navigation"
//           >
//             <span className="navbar-toggler-icon"></span>
//           </button>
//           <div
//             className="collapse navbar-collapse text-center"
//             id="navbarSupportedContent"
//           >
//             <ul className="navbar-nav">
//               <li className="nav-item  ms-3">
//                 <NavLink
//                   className="nav-link text-dark active"
//                   aria-current="page"
//                   to="/"
//                 >
//                   Home
//                 </NavLink>
//               </li>
//               <li className="nav-item ms-3">
//                 <NavLink className="nav-link text-dark " to="/about">
//                   About
//                 </NavLink>
//               </li>
//               {/* <li className="nav-item ms-3">
//                 <NavLink className="nav-link text-dark " to="/merchants">
//                   Merchants
//                 </NavLink>
//               </li> */}
//               <div className="dropdown text-dark nav-link ms-3">
//                 <div
//                   className="text-uppercase dropdown-toggle "
//                   id="dropdownMenuButton1"
//                   data-bs-toggle="dropdown"
//                   aria-expanded="false"
//                   style={{ cursor: "pointer" }}
//                 >
//                   Career
//                 </div>
//                 <ul
//                   className="dropdown-menu"
//                   aria-labelledby="dropdownMenuButton1"
//                 >
//                   <li>
//                     <NavLink
//                       to="/internships"
//                       className="dropdown-item text-uppercase"
//                     >
//                       Internships
//                     </NavLink>
//                   </li>
//                   <li>
//                     <NavLink
//                       className="dropdown-item text-uppercase"
//                       to="/jobs"
//                     >
//                       Jobs
//                     </NavLink>
//                   </li>
//                 </ul>
//               </div>

//               <li className="nav-item ms-3">
//                 <NavLink className="nav-link text-dark " to="/contact">
//                   Contact
//                 </NavLink>
//               </li>
//               <li>
//                 {" "}
//                 <NavLink
//                   style={{ backgroundColor: "#DC2525" }}
//                   className="btn btn-light text-white mt-1 p-2 fw-bold ms-3 btn-sm text-uppercase"
//                   to="/industryprofile"
//                 >
//                   Donate Now
//                 </NavLink>
//               </li>
//             </ul>
//             {/* <div className="dropdown ms-3 mb-1">
//               {!userNotPresent && (
//                 <button
//                   className="btn btn-light rounded-5 fw-bold text-uppercase mt-2 btn-sm "
//                   type="button"
//                   id="dropdownMenuButton1"
//                   data-bs-toggle="dropdown"
//                   aria-expanded="false"
//                 >
//                   Profile
//                 </button>
//               )}
//               <ul
//                 className="dropdown-menu"
//                 aria-labelledby="dropdownMenuButton1"
//               >
//                 <li>
//                   <NavLink
//                     to="/studentprofile"
//                     className="dropdown-item text-uppercase"
//                   >
//                     Student
//                   </NavLink>
//                 </li>
//                 <li>
//                   <NavLink
//                     className="dropdown-item text-uppercase"
//                     to="/industryprofile"
//                   >
//                     Industry
//                   </NavLink>
//                 </li>
//               </ul>
//             </div> */}
//             {student && (
//               <div>
//                 <NavLink
//                   className="btn btn-light  nav-item fw-bold ms-3 btn-sm text-uppercase"
//                   to="/studentprofile"
//                 >
//                   Profile
//                 </NavLink>
//               </div>
//             )}
//             {industry && (
//               <div>
//                 <NavLink
//                   className="btn btn-light nav-item fw-bold ms-3 btn-sm text-uppercase"
//                   to="/industryprofile"
//                 >
//                   Profile
//                 </NavLink>
//               </div>
//             )}
//             {/* {userNotPresent && (
//               <Dropdown>
//                 <MenuButton className="bg-white ms-3" style={{ width: "6rem" }}>
//                   LOGIN
//                 </MenuButton>
//                 <Menu className="mt-4">
//                   <MenuItem>
//                     <NavLink
//                       to="/loginstudent"
//                       className="dropdown-item text-uppercase "
//                     >
//                       Citizen
//                     </NavLink>
//                   </MenuItem>
//                   <MenuItem>
//                     <NavLink
//                       className="dropdown-item text-uppercase"
//                       to="/loginorg"
//                     >
//                       Merchant
//                     </NavLink>
//                   </MenuItem>
//                 </Menu>
//               </Dropdown>
//             )} */}
//             <div className="nav-item ms-3 mt-1">
//               {student && (
//                 <div
//                   className="nav-link "
//                   onClick={() => logoutAccess("Student")}
//                 >
//                   <button className="btn btn-danger fw-bold text-uppercase  btn-sm ">
//                     Logout
//                   </button>
//                 </div>
//               )}
//             </div>
//             <div className="nav-item ms-1 mt-1">
//               {industry && (
//                 <div
//                   className="nav-link "
//                   onClick={() => logoutAccess("Industry User")}
//                 >
//                   <button className="btn btn-danger fw-bold text-uppercase  btn-sm ">
//                     Logout
//                   </button>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </nav>
//     </>
//   );
// };

// export default Header;

import React, { useState } from "react";
import "./header.css";
import { NavLink } from "react-router-dom";
import { Button } from "@mui/material";
import { AiFillContacts, AiFillMail } from "react-icons/ai";
import { logoutAccess, useSelectAccess } from "../../store/stateFunctions";

const Header = () => {
  const student = useSelectAccess("Student");
  const industry = useSelectAccess("Industry User");
  const merchant = useSelectAccess("Merchant");

  const userNotPresent = !student && !industry && !merchant;

  return (
    <>
      {/* --- Top Contact Info Bar --- */}
      <div className="container-fluid bg-light py-2 border-bottom">
        <div className="row align-items-center px-3">
          <div className="col-md-6 text-center  gap-3">
            <a
              href="https://www.facebook.com/mynashikmc/"
              target="_blank"
              rel="noreferrer"
            >
              <i className="fab mx-2 fa-facebook  fa-lg text-primary"></i>
            </a>
            <a
              href="https://www.instagram.com/my_nmc/"
              target="_blank"
              rel="noreferrer"
            >
              <i className="fab mx-2 fa-instagram fa-lg text-danger"></i>
            </a>
            <a
              href="https://www.youtube.com/c/mynmc"
              target="_blank"
              rel="noreferrer"
            >
              <i className="fab mx-2 fa-youtube fa-lg text-danger"></i>
            </a>
            <a
              href="https://twitter.com/my_nmc"
              target="_blank"
              rel="noreferrer"
            >
              <i className="fab mx-2 fa-twitter fa-lg text-info"></i>
            </a>
          </div>
          <div className="col-md-6 text-center">
            <span className="me-3">
              <AiFillMail /> marathwadasfoundation@gmail.com
            </span>
            <span>
              <AiFillContacts /> ९५४५८३४२२२ / ९६३७९५४८७७
            </span>
          </div>
        </div>
      </div>

      {/* --- Logo and Title --- */}
      <div className="container py-3 text-center">
        <div className="row align-items-center">
          <div className="col-md-1">
            <NavLink to="/" className="navbar-brand">
              <img src="/images/Untitled design.png" width={100} alt="Logo" />
              <br />
              <b style={{ color: "orangered" }}> सहकार्यातून राष्ट्र निर्माण</b>
            </NavLink>
          </div>
          <div className="col-md-9">
            <h1 className="fw-bold  fs-1" style={{ color: "orangered" }}>
              मराठवाडा सामाजिक फाऊंडेशन, महाराष्ट्र
            </h1>
            <h3 className="fw-bold">
              Marathwada Samajik Foundation, Maharashtra
            </h3>
            <p className="fw-bold">Reg. No. NSK/0000556/2022</p>
          </div>
          <div className="col-md-2 align-self-center mt-1">
            <img
              src="/team/t5.jpeg"
              className="border border-danger border-2 rounded-circle"
              width={100}
              i
              alt=""
            />
            <h6 className="mt-1 " style={{ fontWeight: "800" }}>
              मा.श्री.आबासाहेब टरपले <br />{" "}
              <span className="mt-2">संस्थापक अध्यक्ष</span>
            </h6>
          </div>
        </div>
      </div>

      {/* --- Navigation Bar --- */}
      <nav className="navbar navbar-expand-lg shadow-sm sticky-top bg-danger text-white border-top border-bottom">
        <div className="container">
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div
            className="collapse navbar-collapse justify-content-between"
            id="navbarSupportedContent"
          >
            <ul className="navbar-nav text-uppercase fw-bold">
              <li className="nav-item ms-3">
                <NavLink className="nav-link fw-bold text-white" to="/">
                  होम
                </NavLink>
              </li>

              <li className="nav-item dropdown ms-3">
                <span
                  className="nav-link  dropdown-toggle text-white"
                  id="careerDropdown"
                  data-bs-toggle="dropdown"
                  style={{ cursor: "pointer" }}
                >
                  संस्थेबद्दल
                </span>
                <ul className="dropdown-menu" aria-labelledby="careerDropdown">
                  <li>
                    <NavLink className="dropdown-item" to="/about">
                      संस्थेबद्दल
                    </NavLink>
                  </li>
                  <li>
                    <NavLink className="dropdown-item" to="/team">
                      टीम
                    </NavLink>
                  </li>
                </ul>
              </li>
              <li className="nav-item dropdown ms-3">
                <span
                  className="nav-link fw-bold  dropdown-toggle text-white"
                  id="careerDropdown"
                  data-bs-toggle="dropdown"
                  style={{ cursor: "pointer" }}
                >
                  करिअर
                </span>
                <ul className="dropdown-menu" aria-labelledby="careerDropdown">
                  <li>
                    <NavLink className="dropdown-item" to="/internships">
                      इंटर्नशिप्स
                    </NavLink>
                  </li>
                  <li>
                    <NavLink className="dropdown-item" to="/jobs">
                      जॉब्स
                    </NavLink>
                  </li>
                </ul>
              </li>
              <li className="nav-item ms-3">
                <NavLink className="nav-link fw-bold  text-white" to="/gallery">
                  गॅलरी
                </NavLink>
              </li>
              <li className="nav-item ms-3">
                <NavLink className="nav-link  text-white" to="/contact">
                  संपर्क
                </NavLink>
              </li>

              <li className="nav-item ms-3">
                <NavLink
                  to="/donation"
                  className="btn btn-light fw-bold  text-dark fw-bold btn-sm px-3 py-2"
                >
                  Donate Now
                </NavLink>
              </li>
            </ul>

            {/* --- Profile Dropdown if Logged In --- */}
            {!userNotPresent && (
              <div className="dropdown ms-3">
                <button
                  className="btn btn-outline-dark dropdown-toggle text-uppercase fw-bold btn-sm"
                  type="button"
                  data-bs-toggle="dropdown"
                >
                  Profile
                </button>
                <ul className="dropdown-menu">
                  {student && (
                    <li>
                      <NavLink to="/studentprofile" className="dropdown-item">
                        Student Profile
                      </NavLink>
                    </li>
                  )}
                  {industry && (
                    <li>
                      <NavLink to="/industryprofile" className="dropdown-item">
                        Industry Profile
                      </NavLink>
                    </li>
                  )}
                </ul>
              </div>
            )}

            {/* --- Login Options If Not Logged In --- */}
            {/* {userNotPresent && (
              <div className="dropdown ms-3">
                <button
                  className="btn btn-outline-primary dropdown-toggle text-uppercase fw-bold btn-sm"
                  type="button"
                  data-bs-toggle="dropdown"
                >
                  Login
                </button>
                <ul className="dropdown-menu">
                  <li>
                    <NavLink to="/loginstudent" className="dropdown-item">
                      Citizen Login
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/loginorg" className="dropdown-item">
                      Merchant Login
                    </NavLink>
                  </li>
                </ul>
              </div>
            )} */}

            {/* --- Logout Buttons --- */}
            {(student || industry) && (
              <div className="ms-3">
                <button
                  className="btn btn-danger text-uppercase fw-bold btn-sm"
                  onClick={() =>
                    student
                      ? logoutAccess("Student")
                      : logoutAccess("Industry User")
                  }
                >
                  Logout
                </button>
              </div>
            )}
          </div>
        </div>
      </nav>
    </>
  );
};

export default Header;
